import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { supabase, safeNext } from '../../lib/supabase';

export default function AuthCallback() {
  const navigate = useNavigate(); const [params] = useSearchParams(); const [error, setError] = useState('');
  useEffect(() => {
    (async () => {
      const code = params.get('code'); const tokenHash = params.get('token_hash'); const type = params.get('type');
      const desc = params.get('error_description') || params.get('error');
      if (desc) return setError(desc.replace(/\+/g, ' '));
      let result;
      if (code) result = await supabase.auth.exchangeCodeForSession(code);
      else if (tokenHash && ['email', 'signup', 'recovery', 'magiclink'].includes(type)) result = await supabase.auth.verifyOtp({ token_hash: tokenHash, type: type === 'signup' ? 'email' : type });
      else if (window.location.hash.includes('access_token')) {
        const h = new URLSearchParams(window.location.hash.slice(1));
        result = await supabase.auth.setSession({ access_token: h.get('access_token'), refresh_token: h.get('refresh_token') });
        if (h.get('type') === 'recovery') return navigate('/reset-password', { replace: true });
      } else return setError('This link is missing its confirmation code. Please request a new one.');
      if (result?.error) return setError(result.error.message);
      const stored = sessionStorage.getItem('nc_next'); sessionStorage.removeItem('nc_next');
      if (type === 'recovery' || params.get('next') === '/reset-password') return navigate('/reset-password', { replace: true });
      navigate(safeNext(params.get('next') || stored, '/app'), { replace: true });
    })();
  }, [params, navigate]);
  return <div className="container-x py-24 text-center" data-testid="auth-callback">
    {error ? <><p className="text-sm text-rose-700" role="alert">{error}</p><p className="mt-3 text-sm">Links expire and can only be used once. <Link to="/login" className="underline">Log in</Link> or <Link to="/signup" className="underline">sign up again</Link>.</p></> : <p className="text-sm text-muted-foreground">Completing sign-in…</p>}
  </div>;
}
